/* eslint-disable */
var boostPFS = new BoostPFS();
if (window.location.hostname.indexOf('bonlook-ca-staging.myshopify.com') > -1 === false) {
  boostPFS.init();
  if (typeof boostPFSConfig != 'undefined'
    && typeof boostPFSConfig.general != 'undefined'
    && typeof boostPFSConfig.general.isInitFilter != 'undefined'
    && boostPFSConfig.general.isInitFilter === true) {
    boostPFS.initFilter();
  }
  BoostPFS.jQ(window).on('load', function(){
    false && boostPFS.initAnalytics();
  });
}
